export default () => {
	let isScrolling = false

	window.addEventListener('scroll', throttleScroll, false)

	function throttleScroll(e) {
		if (isScrolling == false) {
			window.requestAnimationFrame(function () {
				scrolling(e)
				isScrolling = false
			})
		}
		isScrolling = true
	}

	document.addEventListener('DOMContentLoaded', scrolling, false)

	function scrolling(e) {
		let goldenBlocks = document.querySelectorAll('.golden-collection__block')
		goldenBlocks.forEach((block) => {
			if (isFullyVisible(block)) {
				block.classList.add('golden-collection__block_active')

				block.classList.contains('golden-collection__block_1') ||
				block.classList.contains('golden-collection__block_2')
					? block.classList.add('golden-collection__block_active_down')
					: block.classList.contains('golden-collection__block_4')
					? block.classList.add('golden-collection__block_active_left')
					: block.classList.add('golden-collection__block_active_up')
			} else if (isPartiallyVisible(block)) {
			} else {
				block.classList.remove('golden-collection__block_active')
			}
		})
	}

	function isPartiallyVisible(el) {
		let elementBoundary = el.getBoundingClientRect()

		let top = elementBoundary.top
		let bottom = elementBoundary.bottom
		let height = elementBoundary.height

		return top + height >= 0 && height + window.innerHeight >= bottom
	}
	function isFullyVisible(el) {
		let elementBoundary = el.getBoundingClientRect()

		let top = elementBoundary.top
		let bottom = elementBoundary.bottom

		return top >= 0 && bottom <= window.innerHeight
  }
  document.querySelector('.video_hide')?.classList.add('video_visible');

  document.querySelector('.video_hide') ? setTimeout(() => {
      document.querySelector('.video_hide').classList.remove('video_hide');
    },2000) : null
}
